import { render } from "./CreateProducts.vue?vue&type=template&id=fa090350&scoped=true&ts=true"
import script from "./CreateProducts.vue?vue&type=script&lang=ts"
export * from "./CreateProducts.vue?vue&type=script&lang=ts"

import "./CreateProducts.vue?vue&type=style&index=0&id=fa090350&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa090350"]])

export default __exports__